import Backbone from 'backbone'
import Product from '../models/product'

let Products
export default Products = (function () {
  Products = class Products extends Backbone.Collection {
    static initClass() {
      this.prototype.model = Product
    }
    getSubtotal() {
      return this.reduce((sum, product) => sum + product.get('subtotal'), 0)
    }
    getSavingsTotal() {
      return this.reduce(
        (
          sum,
          product // There aren't any discounts for add ons right now, so we only apply the discount to the product
        ) =>
          sum +
          product.get('subtotalSingle') *
            (product.get('item').get('discountPercentage') / 100),
        0
      )
    }
  }
  Products.initClass()
  return Products
})()
